const STORAGE_KEY = "dolmit_effective_role";
const LEGACY_KEY = "dolmit_role";
const ALLOWED = new Set(["pm", "lead", "accountant"]);

export type EffectiveRole = "pm" | "lead" | "accountant";

function isAllowed(value: string): value is EffectiveRole {
  return ALLOWED.has(value);
}

export function getEffectiveRole(): EffectiveRole | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  return isAllowed(raw) ? raw : null;
}

export function setEffectiveRole(role: EffectiveRole | null): void {
  if (role === null) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, role);
}

function migrateLegacyKey(): void {
  const legacy = localStorage.getItem(LEGACY_KEY);
  if (legacy === null) return;
  if (isAllowed(legacy) && localStorage.getItem(STORAGE_KEY) === null) {
    localStorage.setItem(STORAGE_KEY, legacy);
  }
  localStorage.removeItem(LEGACY_KEY);
}

if (typeof localStorage !== "undefined") {
  migrateLegacyKey();
}

export function applyRoleSwitch(role: "admin" | EffectiveRole): void {
  if (role === "admin") {
    setEffectiveRole(null);
  } else {
    setEffectiveRole(role);
  }
  window.location.reload();
}
